<div class="app" [ngClass]="theme$() ?? ''" [class.has--action-bar]="!!actionBar$()">
  <div class="app__inner" [class.anim--in]="loading$()">
    @if (loaded$()) {
      <app-topbar
        (toggleOverlay)="toggleMenu()"
        (closeOverlay)="closeMenu()"
        (openOverlay)="openMenu()"
        [searchOpen]="searchOpen$() ?? false"
        [menuActive]="menuOpen$() ?? false"
        [storefront]="activeStorefront$() || null"
        [menu]="('main-menu' | fromMenu)?.error ? [] : ('main-menu' | fromMenu: activeLanguage$() ?? '')"
        [transparent]="menuTransparent$() ?? true"
        [cartCount]="cart$()?.lines?.length || 0"
        (toggleCart)="toggleCart()"
        [url]="routeState$()?.state?.url"
      >
        @if (actionBar$(); as actionBar) {
          <app-action-bar action-bar [actionBar]="actionBar"></app-action-bar>
        }
        @if (loaded$()) {
          <app-lang-switcher language-bar [languages]="languages$() ?? []" [activeLang]="activeLanguage$() ?? ''"></app-lang-switcher>
        }
      </app-topbar>
    }

    <!-- Please test before implementation! [@routerFade]="prepareRoute(outlet)" -->
    <div class="app__router">
      <router-outlet #outlet="outlet"></router-outlet>

      <div class="app__router__overlay" [class.is--active]="searchOpen$() === true" (click)="closeOverlays()"></div>
    </div>

    @defer {
      @if (cart$(); as cartUpdate) {
        <div class="app__sidebar cart-panel" [class.is--open]="cartPaneOpen$()">
          <!--<ng-container *ngIf="(cartPaneOpen$()) === true">-->
          <div class="app__sidebar__overlay" (click)="closeSidebar()"></div>
          <div class="app__sidebar__panel">
            <app-cart
              [showList]="cartPaneOpen$()"
              [cart]="cartUpdate"
              [cookiePrefs]="cookiePrefs$()"
            ></app-cart>
          </div>
          <!--</ng-container>-->
        </div>
      }
      @if (cart$(); as cart) {
        <div class="app__snackbar snackbar d-md-none" [class.is--open]="cartPaneOpen$()">
          @if (getNewLine(cart.lines); as newLine) {
            <div class="snackbar__product type-body-sm fw-semi">
              <img [src]="newLine.merchandise.image.url" [alt]="newLine.merchandise.image.altText" />
              <span class="snackbar__product__title">{{ newLine.quantity }}x {{ newLine.merchandise.product.title }}</span>
            </div>
          }
          <div class="mx-2 d-flex align-items-center">
            <a [routerLink]="['/cart']" class="button button-link button--primary me-3">Naar winkelwagen</a>
            <app-icon class="icon-xxs icon-secondary" anchor="icon-close-xs" (click)="closeSidebar()"></app-icon>
          </div>
        </div>
      }
    }
    <!-- (fstrInViewport)="openNewsletterPopup()" -->
    @defer (hydrate on viewport) {
      @if (loaded$()) {
        <app-footer
          [menu]="('footer-menu' | fromMenu)?.error ? [] : ('footer-menu' | fromMenu: activeLanguage$() ?? '')"
          [socials]="socialChannels$()"
          [storefront]="activeStorefront$() || null"
          [metaList]="('footer-sub-menu' | fromMenu)?.error ? [] : ('footer-sub-menu' | fromMenu: activeLanguage$() ?? '')"
        >
          <button (click)="openNewsletterPopup()" class="button button--secondary" footer-newsletter>
            {{ 'nieuwsbrief-aanmelden-titel' | fromDictionary }}
          </button>
        </app-footer>
      }
    }
  </div>
  @if (loaded$()) {
    <fstr-cookie-notice
      [title]="'cookie-titel' | fromDictionary"
      [text]="'cookie-tekst' | fromDictionary"
      [buttonAccept]="'cookie-accepteer-knop-tekst' | fromDictionary"
      [buttonAcceptAll]="'cookie-accept-all' | fromDictionary"
      [buttonReject]="'cookie-afwijzen-knop-tekst' | fromDictionary"
    ></fstr-cookie-notice>
  }

  <app-loader-indicator [loading]="loading$()"></app-loader-indicator>
</div>

@if (testGridEnabled) {
  <app-grid-overlay></app-grid-overlay>
}
